import { render, staticRenderFns } from "./HeroBox.vue?vue&type=template&id=c35897a0&scoped=true&"
import script from "./HeroBox.vue?vue&type=script&lang=js&"
export * from "./HeroBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35897a0",
  null
  
)

export default component.exports